import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthSelectors } from 'app/auth/store/auth.selectors';

@Directive({
  selector: '[appHasPermission]',
  standalone: true,
})
export class PermissionDirective {
  private store = inject(Store);
  private userPermissions: Record<string, string>[] = [];

  // default = OR
  private mode: 'any' | 'all' = 'any';

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    this.store.select(AuthSelectors.getPermissions).subscribe((permissions) => {
      this.userPermissions = permissions ?? [];
      this.updateView();
    });
  }

  private requiredPermissions: string[] = [];

  @Input('appHasPermission')
  set permissions(value: string | string[]) {
    if (!value) {
      this.requiredPermissions = [];
      this.viewContainer.clear();
      return;
    }

    this.requiredPermissions = Array.isArray(value)
      ? value
      : value.split(/\s+/).filter(Boolean);

    this.updateView();
  }

  @Input('appHasPermissionMode')
  set permissionMode(value: 'any' | 'all') {
    this.mode = value ?? 'any';
    this.updateView();
  }

  private updateView(): void {
    if (!this.requiredPermissions.length || !this.userPermissions.length) {
      this.viewContainer.clear();
      return;
    }

    const userPermKeys = this.userPermissions.map((p) => Object.keys(p)[0]);

    const hasPermission =
      this.mode === 'all'
        ? this.requiredPermissions.every((perm) => userPermKeys.includes(perm))
        : this.requiredPermissions.some((perm) => userPermKeys.includes(perm));

    this.viewContainer.clear();

    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
